var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"access-token-loader"},[_c('b-loading',{attrs:{"is-full-page":true,"active":true}}),_c('div',{staticClass:"loader-message"},[_vm._v(" "+_vm._s(_vm.$t('loading'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }